const MARK_ATTR = 'data-sop-markup';

export function clearDomHighlights(root: HTMLElement): void {
  const marks = root.querySelectorAll(`mark[${MARK_ATTR}]`);
  marks.forEach((mark) => {
    const parent = mark.parentNode;
    if (!parent) return;
    while (mark.firstChild) parent.insertBefore(mark.firstChild, mark);
    parent.removeChild(mark);
    parent.normalize();
  });
}

export function applyDomHighlights(root: HTMLElement, quotes: string[]): void {
  clearDomHighlights(root);
  const unique = [...new Set(quotes.map((q) => q.trim()).filter((q) => q.length >= 2))];
  for (const quote of unique) {
    wrapFirstMatch(root, quote);
  }
}

function wrapFirstMatch(root: HTMLElement, quote: string): void {
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  let node: Node | null = walker.nextNode();
  while (node) {
    const text = node.textContent ?? '';
    const idx = text.indexOf(quote);
    if (idx === -1) {
      node = walker.nextNode();
      continue;
    }
    if ((node.parentElement as HTMLElement | null)?.closest?.(`mark[${MARK_ATTR}]`)) {
      node = walker.nextNode();
      continue;
    }
    const textNode = node as Text;
    const before = textNode.splitText(idx);
    const after = before.splitText(quote.length);
    const mark = document.createElement('mark');
    mark.setAttribute(MARK_ATTR, 'highlight');
    mark.className = 'sop-markup-hl rounded px-0.5 py-0.5';
    mark.style.backgroundColor = 'rgba(250, 204, 21, 0.55)';
    mark.appendChild(before);
    after.parentNode?.insertBefore(mark, after);
    return;
  }
}
